<template>
  <div class="share-tree-page">
    <div class="icon-title">
      <img src="@/assets/icons/share_tree_180.png" alt="Share tree icon" />
      <h1>Ask a family member to<br>share their tree</h1>
    </div>
    <div class="subtitle">
      If you know someone who has already started building your family tree, try searching for them here, and we’ll help you connect.
    </div>
    <form class="search-row"> 
      <input
        type="text"
        placeholder="Type the name of a tree or tree owner"
        class="search-input"
      />
      <button class="btn btn-primary" type="submit">Search</button>
    </form>
    <div class="help-link-row">
      <a href="#" class="help-link">What if I can’t find them?</a>
    </div>
    <div class="secondary-instructions">
      Try contacting your family member directly. Once they create an account on
      <strong>treecrossing.com</strong>, they can share their tree with you.
    </div>
  </div>
</template>

<style scoped>
.share-tree-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
  font-family: 'Noto Sans', sans-serif;
}
.icon-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;
}

.icon-title img {
  width: 120px;
  height: 160px;
  margin-bottom: 1.2rem;
}

.icon-title h1 {
  font-size: 3.5rem;
  font-weight: 300;
  text-align: left;
  line-height: 1.08;
  margin: 0;
  color: #222;
  padding: 30px 30px 35px 30px;
  line-height: 1.2;
  @media (max-width: 700px) {
    text-align: center;
  }
}

.subtitle {
  font-size: 1.35rem;
  text-align: center;
  margin-bottom: 2.2rem;
  color: #222;
  max-width: 800px;
}

.search-row {
  display: flex;
  @media (max-width: 700px) {
    flex-direction: column;
  }
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 540px;
  margin-bottom: 2.5rem;
  gap: 2rem;
}

.search-input {
  flex: 1;
  font-size: 1rem;
  padding: 0.7rem 1rem;
  border: 2px solid #b3d4fc;
  border-radius: 6px;
  outline: none;
  background: #fff;
  transition: border 0.2s;
}

.search-input:focus {
  border-color: #1976d2;
}

.btn {
    height: 50px;
    width: 80px;
}

.search-btn:hover {
  background: #125ea2;
}

.help-link-row {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 2.5rem;
}

.help-link {
  color: #1976d2;
  font-size: 1.1rem;
  text-decoration: none;
  transition: text-decoration 0.2s;
}

.help-link:hover {
  text-decoration: underline;
}

.secondary-instructions {
  margin-top: 1.5rem;
  font-size: 1.25rem;
  color: #222;
  text-align: center;
  max-width: 700px;
  margin-bottom: 2rem;
}

.site-name {
  font-weight: 600;
  color: #1976d2;
}

@media (max-width: 700px) {
  .icon-title h1 {
    font-size: 2.2rem;
  }
  .subtitle,
  .secondary-instructions {
    font-size: 1rem;
    max-width: 95vw;
  }
  .search-row {
    max-width: 98vw;
  }
}
</style>